module.exports = __webpack_public_path__ + "static/media/select-captain.94d730cd.svg";